import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const BIRelationshipScopeContext = /*#__PURE__*/ createContext(null);
export const BIRelationshipScopeProvider = (param)=>{
    let { relationshipScope, children } = param;
    return /*#__PURE__*/ _jsx(BIRelationshipScopeContext.Provider, {
        value: relationshipScope,
        children: children
    });
};
export const useBIRelationshipScope = ()=>{
    return useContext(BIRelationshipScopeContext);
};
